export const normalizeOfferStatus = (status) => ({
  A: 'ACTIVE', D: 'SCHEDULED', P: 'PAUSED', E: 'EXPIRED', X: 'ARCHIVED',
}[String(status).toUpperCase()] || String(status).toUpperCase());

export const canEditOffer = (status) => ['SCHEDULED', 'PAUSED'].includes(normalizeOfferStatus(status));
export const canArchiveOffer = (status) => ['SCHEDULED', 'PAUSED', 'EXPIRED'].includes(normalizeOfferStatus(status));
export const canPauseOffer = (status) => ['ACTIVE', 'SCHEDULED'].includes(normalizeOfferStatus(status));
export const canActivateOffer = (status) => normalizeOfferStatus(status) === 'PAUSED';
export const offerSaveImpact = (status) => normalizeOfferStatus(status) === 'PAUSED'
  ? 'This offer will stay paused. Activate it separately when you are ready.'
  : 'Saving recalculates the schedule. If the start date has arrived, this offer may go live immediately, subject to your balance and offer limits.';
